<div class="graph"></div>


@if (isLineChartLoder) {
  <div class="custom-table-list-row-main">
    <div class="custom-col-width-100 text-danger d-flex justify-content-center">
      <app-common-icon [loadingIcon]="true"></app-common-icon>
    </div>
  </div>
}

@if ((!data || data.length === 0) && !isLineChartLoder) {
  <div class="color-red">
    <p>No Data Found !</p>
  </div>
}
